export const components = {
  '* The time is up, send another code to continue':
    '* El tiempo se terminó, envíe otro código para continuar.',
  'All rights reserved to Vialaser Servicos Esteticos S.A - {{year}}':
    'Todos los derechos reservados a Vialaser Servicios Estéticos S.A - {{year}}',
  'Almost there!': '¡Casi allí!',
  'App at appstore': 'App en appstore',
  'App at google play': 'App en google play',
  'As soon as three friends, that dont know Vialaser yet, register themselves, you will get an <1>{{value}} exclusive coupon</1> at your email for the purchase of any package':
    'Tan pronto como tres amigos, que aún no conocen Vialaser, se registren, recibirás en tu correo electrónico un <1>cupón exclusivo de {{value}}</1> para la compra de cualquier paquete.',
  'At Vialaser your recommendation means a looooot! <1>Up to {{value}} in discounts</1> of your installments <3>Enjoy!</3>':
    'En Vialaser tu recomendación vale muuuuuucho! <1>Hasta {{value}} de descuento</1> en tus cuotas. <3>Aprovecha!</3>',
  'A true friend is the one that refer <1>{{value}} in discounts</1> to you and your friends <3>Enjoy!</3>':
    'Un verdadero amigo es el que recomienda. <1>{{value}} de descuento</1>  para ti y tus amigos. <3>Aproveche!</3>',
  'Be franchised': 'Conviértete en franquiciado',
  'Below you may leave a comment of your choice about the session':
    'A continuación podrás realizar cualquier comentario de tu elección sobre la sesión.',
  Blog: 'Blog',
  'Buy now': 'Comprar ahora',
  Cart: 'Cesto',
  'Choose other sending option': 'Escoger otra opción de envío',
  'Citizen Service': 'Atención Ciudadana',
  'Click here to sign in!': '¡Haz clic aquí para registrarte!',
  Close: 'Cerrar',
  Combos: 'Combos',
  Contact: 'Contacto',
  Contracts: 'Contratos',
  'Copy link': 'Copiar enlace',
  'Coupon valid only for purchases above {{value}}':
    '* Cupón válido para compras superiores a {{value}}',
  'Credit card': 'Tarjeta de crédito',
  'Create your account': 'Crea tu cuenta',
  'Customer area': 'Área del cliente',
  'CUSTOMER WEEK ⚡ BUY A COMBO AND GET A FREE AREA!':
    'SEMANA DEL CONSUMIDOR ⚡ ¡COMPRA UN COMBO Y OBTÉN ÁREA GRATIS!',
  Day_one: 'Día',
  Day_other: 'Días',
  "Don't have a Vialaser account yet?":
    '¿Todavía no tienes tu cuenta en Vialaser?',
  '<0>Double discount</0> by referring three friends, you and them both get a super discount 🥰':
    '<0>Descuento doble:</0> si recomendás a tres amigos, ganás un súper descuento ¡y ellos también! 🥰',
  'E-mail': 'Correo electrónico',
  Enter: 'Entrar',
  'Evaluate session': 'Evaluar sesión',
  Exit: 'Salir',
  'Find a clinic': 'Encuentra una clínica',
  'Follow Vialaser at our Social Networks':
    'Sigue a Vialaser en nuestras Redes Sociales:',
  'From 1 to 10 tell us what did you think about your {{regions}} session with the applicator {{applicator}}':
    'Del 1 al 10, cuéntanos qué te pareció tu sesión de {{regions}} con el aplicador {{applicator}}.',
  'Give your feedback!': '¡Danos tu opinión!!',
  'Hello,<1></1>{{name}}!': '¡Hola,<1></1>{{name}}!',
  Home: 'Inicio',
  Hour_one: 'Hora',
  Hour_other: 'Horas',
  'I wanna know how it works': 'Quiero saber cómo funciona',
  "I'm interested in knowing more about laser hair removal promotions":
    'Tengo interés en saber más sobre promociones de depilación láser',
  'Leave feedback on Google': 'Dejar reseña en Google',
  'Link successfully copied!': '¡Enlace copiado con éxito!',
  'Loading terms': 'Cargando terminos...',
  Minutes: 'Minutos',
  'My data': 'Mis datos',
  'My recommendations': 'Mis recomendaciones',
  Next: 'Próximo',
  optional: 'opcional',
  "Our friendship is worth millions and in Vialaser it's worth a discount! 😍%0aWin a {{discount}} discount on the purchase of a hair removal package at Vialaser by subscribing with my link, but remember, this cupon is only valid for purchases up to {{minValue}} %0a%0a{{link}}":
    'Nuestra amistad vale millones, ¡y en Vialaser vale un descuento! 😍%0aObtén un descuento de {{discount}} en la compra de un paquete de depilación láser en Vialaser al inscribirte en mi enlace, pero recuerda, este cupón es válido para compras superiores a {{minValue}}. %0a%0a{{link}}',
  'Our technology': 'Nuestra tecnología',
  Packages: 'Paquetes',
  'Payment methods': 'Formas de pago',
  'Privacy policies': 'Políticas de privacidad',
  'Please, contact an attendant to solve the issue':
    'Comuníquese con un representante de servicio al cliente para resolver el problema.',
  'Recommend and Win!': 'Indique y Gane!',
  'Recommend your friends and gain priceless discounts':
    'Indica a tus amigos y gane descuentos imperdíbles',
  'Recurrent card': 'Tarjeta recurrente',
  'Sales center': 'Centro de Ventas',
  'Schedule session': 'Programar sesión',
  Schedulings: 'Cítas',
  'Search packages at Vialaser': 'Buscar paquetes en Vialaser',
  Seconds: 'Segundos',
  'Send again': 'Enviar de nuevo',
  'Send again in {{count}}s': 'Enviar de nuevo en {{count}}s',
  Sessions: 'Sesuibes',
  'Share your link via Whatsapp': 'Comparte tu enlace a través de WhatsApp',
  'Sign up': 'Iniciar sesión',
  'Since you like our services, how about leaving a feedback on Google?':
    'Ya que te gustaron nuestros servicios, ¿qué te parece si nos dejás una reseña en Google?',
  'Something unexpected happened!': '¡Algo inesperado sucedió!',
  'Terms of use': 'Terminos de uso',
  'Thanks for the evaluation!': '¡Gracias por tu evaluación!',
  'The code is valid only for {{count}} minutes_one':
    'El código sólo es válido durante {{count}} minuto.',
  'The code is valid only for {{count}} minutes_other':
    'El código sólo es válido durante {{count}} minutos.',
  'The link could not be copied Please try again!':
    'No se puede copiar el enlace. ¡Inténtalo de nuevo!',
  'The link could not be shared Please try again!':
    'No se puede compartir el enlace. ¡Inténtalo de nuevo!',
  'There is no channel available for sending you the code':
    'No hay ningún canal disponible para enviarle el código de validación',
  'There was an error finding the accession terms':
    'Se produjo un error al obtener los términos de adhesión.',
  'Time left': 'Tiempo restante:',
  'Type the last code you received in your email {{email}}':
    'Digite el último código que llegó por e-mail a {{email}}.',
  'Type the last code you received in your whatsapp with final number of {{phone}}':
    'Digite el último código que llegó por WhatsApp al número {{phone}}.',
  'Type the last code you received in your phone with final number of {{phone}}':
    'Digite el último código que llegó por SMS al número {{phone}}.',
  'Validate code': 'Validar codigo',
  Validation: 'Validación',
  'Verification code': 'Código de verificación',
  'Vialaser - Hair removal clinic with exclusive technology':
    'Vialaser - Clínica de depilación láser con tecnología exclusiva',
  Visitor: 'Visitante',
  'With 1 being a terrible application and 10 an excellent one':
    'Siendo 1 una aplicación pésima y 10 excelente.',
  'Where to find': 'Dónde encontrar',
  'Who we are': 'Quienes somos',
  'Work with us': 'Trabaja con nosotros',
  'You can send your personalized link to as many friends as you want <1>The more you indicate, the easier it is to win</1> For each friend who purchases a package over {{minimumBudgetValue}} you receive a <5>discount of {{value}} on your next installment</5> Your referrals <7>also receive a {{discount}} discount</7> to keep their waxing up to date':
    'Puedes enviar tu enlace personalizado a tantos amigos como quieras. <1>Cuanto más indiques, más fácil será ganar.</1> Por cada amigo que compre un paquete arriba de {{minimumBudgetValue}} obtienes un <5>descuento de {{value}} en tu próxima cuota.</5> Tus referidos <7>también reciben un descuento de {{discount}}</7> para mantener su depilación al día.',
  'Your comment here': 'Tu comentario aquí...',
  'Your feedback was registered Thanks!':
    'Tus comentarios han sido enviados con éxito. ¡Gracias!',

  'Ops something went wrong!': 'Ops... Algo salió mal',
  'Something did not worked as expected Try again realoding the page or go to the home':
    'Alguna cosa no funcionó como esperamos. Intenta recargar la página o vuelva al inicio',
  'Refresh page': 'Recargar la página',
  'Go to home': 'Vuelva al inicio',

  'To update your contact data <1>click here</1>':
    'Para cambiar sus datos de contacto haga <1>click aquí.</1>',

  hour_one: 'hora',
  hour_other: 'horas',
  minute_one: 'minuto',
  minute_other: 'minutos',
  second_one: 'segundo',
  second_other: 'segundos',
};
